import { createSelector } from 'reselect'

import { isEmbeddedSelector } from 'selectors/embed'
import { requestSelector } from 'root-api'

const consentCategoriesSelector = (state) => state.consent.categories

export const isGdprAppliedSelector = createSelector(
  requestSelector,
  ({ gdpr_applied: applied }) => applied
)

const shouldHideSelector = ({ gdpr }) => gdpr.isHidden

export const shouldHideOnetrustSelector = createSelector(
  shouldHideSelector,
  isEmbeddedSelector,
  (shouldHide, isEmbedded) => Boolean(shouldHide && isEmbedded)
)

export const isCookiesAllowedSelector = (category = null) => createSelector(
  consentCategoriesSelector,
  (categories) => {
    if (!category) return false
    return categories?.[category] === 'granted'
  }
)

export const isLocalStorageAllowedSelector = isCookiesAllowedSelector
